<div *ngIf="user" class="row mb-3 align-items-center justify-content-between">
  <div class="col-lg">
    <h1 id="header-welcome-message">
      Happy <span id="header-day-of-week">{{ dayOfWeek }}</span
      >, <b>{{ user.profile.first_name }}</b
      >!
    </h1>
  </div>
  <div class="col-8 col-sm-10 col-lg-auto d-flex align-items-center flex-row">
    <ng-container *ngIf="showSwitcher && (user.isLeader || user.isCoach)">
      <div id="dashboard-switcher">
        <div class="btn-group btn-group-sm" role="group">
          <ng-container *ngIf="user.isLeader">
            <input
              type="radio"
              class="btn-check"
              routerLink="/dashboard/leader"
              [checked]="dashboardType == 'leader'"
              id="leader-view-toggle" />
            <label class="btn btn-outline-primary" for="leader-view-toggle">
              Leader View
            </label>
          </ng-container>
          <ng-container *ngIf="user.isCoach">
            <input
              type="radio"
              class="btn-check"
              routerLink="/dashboard/coach"
              [checked]="dashboardType == 'coach'"
              id="coach-view-toggle" />
            <label class="btn btn-outline-primary" for="coach-view-toggle">
              Coach View
            </label>
          </ng-container>
          <input
            type="radio"
            class="btn-check"
            routerLink="/dashboard/learner"
            [checked]="dashboardType == 'learner'"
            id="learner-view-toggle" />
          <label class="btn btn-outline-primary" for="learner-view-toggle">
            Learner View
          </label>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="col-4 col-sm-2 col-md-auto d-flex">
    <div
      *ngIf="canCreateLog"
      ngbTooltip="Create Quick Walk Session"
      #quickWalkTooltip="ngbTooltip"
      placement="top"
      [style.display]="'inline-block'"
      [style.margin-right]="'1rem'">
      <button
        aria-label="quick-walk-session-icon"
        placement="bottom-end"
        class="btn-reset quick-walk-icon"
        (click)="openQuickWalkModal(); quickWalkTooltip.close()">
        <i class="bi bi-clipboard2-check-fill"></i>
      </button>
    </div>
    <div
      ngbTooltip="Throw Confetti"
      #confettiTooltip="ngbTooltip"
      placement="top"
      [style.display]="'inline-block'"
      [style.margin-right]="'1rem'">
      <button
        aria-label="dashboard-celebration-icon"
        placement="bottom-end"
        class="icon btn-reset confetti-icon"
        (click)="cueConfetti(); confettiTooltip.close()">
        <img
          src="/assets/confetti-sm.svg"
          class="confetti"
          alt="Throw confetti" />
      </button>
    </div>

    <ng-container
      *ngIf="celebrateFromCoacheeList; else celebrationPopoverTemplate">
      <div
        ngbTooltip="Celebrate Coachees"
        #celebrateCoacheesTooltip="ngbTooltip"
        placement="top"
        class="celebrations-icon"
        style="margin-right: 1rem"
        (click)="
          createEditCelebrationModal.openModal();
          celebrateCoacheesTooltip.close()
        ">
        <img
          src="/assets/celebrate-star.svg"
          class="cstar"
          alt="celebration star" />
      </div>
    </ng-container>
    <app-notifications-bell />
    <ng-template #celebrationPopoverTemplate>
      <div
        ngbDropdown
        #celebrationsDropdown="ngbDropdown"
        [autoClose]="'outside'"
        placement="bottom-end"
        ngbTooltip="Celebrations"
        #celebrationsTooltip="ngbTooltip"
        [style.display]="'inline-block'"
        style="margin-right: 1rem">
        <button
          ngbDropdownToggle
          aria-label="dashboard-celebration-icon"
          class="btn-reset celebrations-icon"
          (click)="celebrationsTooltip.close()">
          <img
            src="/assets/celebrate-star.svg"
            class="cstar"
            alt="celebration star" />
        </button>
        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-end celebrations-panel">
          <div class="celebrations-scroll">
            <app-card-celebrations-feed
              (createCelebrationEvent)="handleCreateCelebrationEvent()"
              [celebrations]="celebrations"
              [user]="user" />
          </div>
          <div
            class="celebrations-footer d-flex justify-content-between align-items-center">
            <button
              (click)="openCelebrationModal()"
              class="btn btn-warning btn-sm celebrations-create-btn fw-700">
              <i class="bi bi-plus-lg"></i>
              Create a Celebration
            </button>
            <a
              href="javascript:void(0)"
              (click)="goToCelebrationsPage()"
              class="celebrations-see-all fs-14">
              See all Celebrations
            </a>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
  <app-create-edit-celebration-modal
    (createCelebrationEvent)="handleCreateCelebrationEvent()"
    [selectedCoachees]="selectedCoachees"
    [user]="user"
    #createEditCelebrationModal />
  <app-create-quick-walk-modal #createQuickWalkModal />
</div>
